/**
 * Usage-Explorer Fixture.
 * Spec: lmm-wiki/wiki/orbit-specs/nexus-usage-explorer.md
 */

const NOW = Date.now();

const TOP_BY_RESOURCE = {
  cpu_seconds: [
    { subscription_id: 42, label: 'cust-204', total: 184_200, unit: 's', samples: 1440 },
    { subscription_id: 17, label: 'cust-101', total: 92_400, unit: 's', samples: 1440 },
    { subscription_id: 99, label: 'cust-505', total: 41_100, unit: 's', samples: 1440 },
  ],
  ram_bytes: [
    { subscription_id: 42, label: 'cust-204', total: 4 * 1024 ** 3, unit: 'B', samples: 1440 },
    { subscription_id: 17, label: 'cust-101', total: 2 * 1024 ** 3, unit: 'B', samples: 1440 },
  ],
  bandwidth_bytes: [
    { subscription_id: 17, label: 'cust-101', total: 12 * 1024 ** 3, unit: 'B', samples: 720 },
    { subscription_id: 42, label: 'cust-204', total: 8 * 1024 ** 3, unit: 'B', samples: 720 },
  ],
  storage_bytes: [
    { subscription_id: 42, label: 'cust-204', total: 80 * 1024 ** 3, unit: 'B', samples: 720 },
  ],
};

const PLUGIN_STATUS = [
  { plugin_identifier: 'hosting-enhance', last_sample_at: new Date(NOW - 12 * 60_000).toISOString(), sample_count: 4280, healthy: true },
  { plugin_identifier: 'games-pterodactyl', last_sample_at: null, sample_count: 0, healthy: false },
  { plugin_identifier: 'vps-proxmox', last_sample_at: new Date(NOW - 2 * 3600_000).toISOString(), sample_count: 320, healthy: true },
  { plugin_identifier: 'cloud-argocd', last_sample_at: new Date(NOW - 14 * 3600_000).toISOString(), sample_count: 110, healthy: false },
];

export function usageTopFixture({ resourceType }) {
  return { top: TOP_BY_RESOURCE[resourceType] ?? [], resource_type: resourceType };
}

export function usagePluginStatusFixture() {
  return { plugins: PLUGIN_STATUS };
}

export function usageSummaryFixture({ subscriptionId }) {
  return {
    subscription_id: subscriptionId,
    metrics: [
      { resource_type: 'cpu_seconds', aggregation: 'sum', value: 12_400, unit: 's' },
      { resource_type: 'ram_bytes', aggregation: 'avg', value: 1.4 * 1024 ** 3, unit: 'B' },
      { resource_type: 'bandwidth_bytes', aggregation: 'sum', value: 3.2 * 1024 ** 3, unit: 'B' },
      { resource_type: 'storage_bytes', aggregation: 'avg', value: 22 * 1024 ** 3, unit: 'B' },
    ],
  };
}
